
import { BindMiniCardActions, BindMiniCardActionTypes } from '../actions/bind-mini-card.actions';
import {AddUpdateDeviceParams, MiniCardInfo} from '../../../models/devices';

export interface State {
  entity: AddUpdateDeviceParams;
}

export const initialState: State = {
  entity: {},
};

export function reducer(state = initialState, action: BindMiniCardActions): State {
  switch (action.type) {
    case BindMiniCardActionTypes.LoadBindMiniCards:
      return {...state, entity: action.payload};

    case BindMiniCardActionTypes.ClearMiniCards:
      return {...state, entity: {}};

    case BindMiniCardActionTypes.GetBindMiniCards:
      return state;
    default:
      return state;
  }
}
